// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 426 ? "d0709137" : chunkId) + "." + {"54":"188d22c23883d731","184":"5314770d67f4a69d","257":"1a76fa73377d8926","426":"bf410b10ff22706e","643":"efe6b0e522f12c89","945":"edcae61fc0f6e7ed"}[chunkId] + ".js";
};